import React, { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import styles from "./Reason.module.scss";
import axiosClient from "../../service/axios";
import { SyncOutlined } from "@ant-design/icons";
import { adminToast, returnToast } from "../NotificationToast";

function PickRider({ rider, setRider, id, title, values }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({
    threePL: "",
    rider: "",
  });
  // console.log("values", values);
  // console.log("id", id);
  // console.log("title", title);
  const handleModalClose = () => {
    setRider(false);
  };

  const getRider = async () => {
    try {
      const response = await axiosClient.get(
        `/lite/v2/api/v3/start/return/${title}/${id}`
      );

      if (response.status === 200) {
        setData(response.data.data);
      }
    } catch (error) {
      console.log("Error in send to finance", error);
    }
  };

  useEffect(() => {
    getRider();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    const payload = {
      ...values,
      flow: data.Key,
      selectedOptions,
    };
    setLoading(true);
    try {
      const response = await axiosClient.post(
        "/lite/v2/api/v3/return",
        payload
      );
      if (
        response.status === 200 &&
        (data.Key === "Flow 3" || data.Key === "Flow 5")
      ) {
        setLoading(false);
        adminToast();
        handleModalClose();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        // console.log(response);
        setLoading(false);
        returnToast();
        handleModalClose();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <Dialog open={rider} onClose={handleModalClose}>
      <DialogContent style={{ paddingBottom: "0" }}>
        {data.Key === "Flow 1" ? (
          <>
            <div className={styles.title}>Flow 1</div>
            <div className={styles.formContainer}>
              <div className={styles.formGroup}>
                <label htmlFor="threePL">3PL</label>
                <select
                  name="threePL"
                  id="threePL"
                  value={selectedOptions.threePL}
                  onChange={handleChange}
                >
                  <option value="">Select 3PL</option>
                  {data?.intercity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor=""> Rider</label>
                <select
                  name="rider"
                  id="rider"
                  value={selectedOptions.rider}
                  onChange={handleChange}
                >
                  <option value="rider">Select Rider</option>
                  {data?.intracity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </>
        ) : data.Key === "Flow 2" ? (
          <>
            <div className={styles.title}>Flow 2</div>
            <div className={styles.formContainer}>
              <div className={styles.formGroup}>
                <label htmlFor=""> Rider</label>
                <select
                  name="rider"
                  id="rider"
                  value={selectedOptions.rider}
                  onChange={handleChange}
                >
                  <option value="rider">Select Rider</option>

                  {data?.intracity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </>
        ) : data.Key === "Flow 3" ? (
          <>
            <div className={styles.title}>Flow 3</div>
            <div className={styles.formContainer}>
              <p>Push to notify the admin for this return</p>
              {/* <div className={styles.formGroup}>
                <label htmlFor="threePL">3PL</label>

                <select
                  name="threePL"
                  id="threePL"
                  value={selectedOptions.threePL}
                  onChange={handleChange}
                >
                  <option value="">Select 3PL</option>
                  {data?.intercity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div> */}
              {/* <div className={styles.formGroup}>
                <label htmlFor=""> Rider</label>

                <select
                  name="rider"
                  id="rider"
                  value={selectedOptions.rider}
                  onChange={handleChange}
                >
                  <option value="rider">Select Rider</option>
                  {data?.intracity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>
          </>
        ) : data.Key === "Flow 4" ? (
          <>
            <div className={styles.title}>Flow 4</div>
            <div className={styles.formContainer}>
              <div className={styles.formGroup}>
                <label htmlFor="threePL">3PL</label>

                <select
                  name="threePL"
                  id="threePL"
                  value={selectedOptions.threePL}
                  onChange={handleChange}
                >
                  <option value="">Select 3PL</option>
                  {data?.intercity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor=""> Rider</label>

                <select
                  name="rider"
                  id="rider"
                  value={selectedOptions.rider}
                  onChange={handleChange}
                >
                  <option value="rider">Select Rider</option>
                  {data?.intracity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </>
        ) : data.Key === "Flow 5" ? (
          <>
            <div className={styles.title}>Flow 5</div>
            <div className={styles.formContainer}>
              <p>Push to notify the admin for this return</p>
              {/* <div className={styles.formGroup}>
                <label htmlFor="threePL">3PL</label>

                <select
                  name="threePL"
                  id="threePL"
                  value={selectedOptions.threePL}
                  onChange={handleChange}
                >
                  <option value="">Select 3PL</option>
                  {data?.intercity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>
          </>
        ) : null}
      </DialogContent>
      <DialogActions style={{ paddingRight: "49px", paddingBottom: "49px" }}>
        <div
          style={{
            cursor: "pointer",
            color: "#ffffff",
            backgroundColor: "#b70303",
            padding: "10px",
            borderRadius: "3px",
            border: "1px solid #DFE1E6",
            fontSize: "14px",
          }}
          onClick={handleSubmit}
        >
          {/* {loading ? <SyncOutlined Spin /> : "Return"} */}
          {data.Key === "Flow 3" || data.Key === "Flow 5" ? (
            loading ? (
              <SyncOutlined spin />
            ) : (
              "Push To Admin"
            )
          ) : loading ? (
            <SyncOutlined spin />
          ) : (
            "Return"
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default PickRider;
